export class Step1 {
    constructor() {}
  
    intitule = 'stepper.form.commun.divers.step1';
    getspan1 = 'bloc_commun.divers.getspan1';
    getoui = 'bloc_commun.divers.getoui';
    getnon = 'bloc_commun.divers.getnon';
    getclassificationorganisme = 'bloc_commun.divers.getclassificationorganisme';
    getpointdecontact = 'bloc_commun.divers.getpointdecontact';
    getspan2 = 'bloc_commun.divers.getspan2';
    getcivilite = 'bloc_commun.divers.getcivilite';
    getpren = 'bloc_commun.divers.getpren';
    getnom = 'bloc_commun.divers.getnom';
    getfonc = 'bloc_commun.divers.getfonc';
    getacheteurpublic = 'bloc_commun.divers.getacheteurpublic';
    getnum = 'bloc_commun.divers.getnum';
    gettypevoie = 'bloc_commun.divers.gettypevoie';
    getnomvoie = 'bloc_commun.divers.getnomvoie';
    getcp_e = 'bloc_commun.divers.getcp_e';
    getcp = 'bloc_commun.divers.getcp';
    getville = 'bloc_commun.divers.getville';
    getpays = 'bloc_commun.divers.getpays';
    gettel = 'bloc_commun.divers.gettel';
    getposte = 'bloc_commun.divers.getposte';
    getfax = 'bloc_commun.divers.getfax';
    getmel = 'bloc_commun.divers.getmel';
    geturlprofilacheteur = 'bloc_commun.divers.geturlprofilacheteur';
    geturl = 'bloc_commun.divers.geturl';
    getspan3 = 'bloc_commun.divers.getspan3';
    getspan4 = 'bloc_commun.divers.getspan4';
    getdeptpub = 'bloc_commun.divers.getdeptpub';
    getspan5 = 'bloc_commun.divers.getspan5';
    getrappel = 'bloc_commun.divers.getrappel_liste_avi_';


  }
  
